import React, { Fragment, useEffect, useState } from 'react'
import { bool, string } from 'prop-types'
import axios from 'axios'

import Icon from 'Pods/Shared/Icon/Icon'
import UserModalWithTabs from './UserModalWithTabs'

function GuestLoginCheckout({
  source = null,
  fromCheckout = false,
  showVerificationNotice = false,
  useVerificationFlow = false,
}) {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    App.events.subscribe('app:guest:modal:open', openLoginModal)

    if (document.body.classList.contains('show-payment') || showVerificationNotice) {
      setIsOpen(true)
    }
  }, [])

  function trackCartToLogin() {
    axios.put('/cg/checkout/track-cart-to-login-step').catch((error) => {})
  }

  function triggerHJ() {
    window.hj=window.hj||function () { (hj.q=hj.q||[]).push(arguments) }
    hj('trigger', 'login_modal_is_shown')
  }

  function openLoginModal(e) {
    e.preventDefault()
    trackCartToLogin()
    setIsOpen(true)
  }

  function onClose() {
    setIsOpen(false)
    window.location.hash = 'cart'
  }

  function afterOpenModal() {
    window.location.hash = 'payment'
    triggerHJ()
  }

  return (
    <Fragment>
      <a href="#" className="cgt-tab cgt-tab--medium cgt-legacy-heading-h6" onClick={(e) => openLoginModal(e)}>
        2. Payment
      </a>
      <UserModalWithTabs
        source={source}
        fromCheckout={fromCheckout}
        shouldOpen={isOpen}
        onClose={onClose}
        afterOpenModal={afterOpenModal}
        showVerificationNotice={showVerificationNotice}
        useVerificationFlow={useVerificationFlow}
      />
    </Fragment>
  )
}

GuestLoginCheckout.propTypes = {
  source: string,
  fromCheckout: bool,
  showVerificationNotice: bool,
  useVerificationFlow: bool,
}

export default GuestLoginCheckout
